import React, 
{ 
  useEffect, 
  useState 
} from 'react'
import { 
  useSelector, 
  useDispatch 
} from 'react-redux'

import { 
  useGame,
  useUser
} from 'data/hooks'
import * as actions from 'data/redux/actions'

export const useAvatar = (gameId, userId) => {

    const dispatch = useDispatch()
    const user = useSelector(state => state.user) 
    const { users } = useGame(gameId)

    const [ hasavatar, setHasAvatar ] = useState(false)

    const uploadAvatar = (file) => {
        
      return dispatch(actions.uploadWPAvatar(userId, file))
    }

    useEffect(() => {

      if(!gameId) { // In multigame before select game
      
        setHasAvatar(user.hasavatar)
      }

    }, [user])

    useEffect(() => {

      if (!userId) return
      
      if(!gameId) { // In multigame before select game
        
        if(!user.avatarchecked) {

          dispatch(actions.userCheckHasavatar(userId))
        }

      } else { // An user of game

        if(users) {

          const wpuser = users[userId]

          if (wpuser) {

            setHasAvatar(wpuser.hasavatar)
          }
        }
      }
    }, [users])

    const getAvatarOfUser = uId => {
      return `/wp-content/uploads/playmotiv/avatar/${uId}.jpg?date=${ new Date().getTime() }`
    }

    return {
      hasavatar: hasavatar,
      avatar: hasavatar ?
      `/wp-content/uploads/playmotiv/avatar/${userId}.jpg?date=${ new Date(hasavatar).getTime() }`
      :
      '/wp-content/plugins/playmotiv-cloud-player-v4/assets/images/avatar.png',
      fallback: '/wp-content/plugins/playmotiv-cloud-player-v4/assets/images/avatar.png',
      uploadAvatar,
      getAvatarOfUser
    }
}
